import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { ThirdPartyApiListResponse, ThirdPartyApiState, ThirdPartyApiSummary } from "./type";

const initialSummary: ThirdPartyApiSummary = {
  total: 0,
  healthy: 0,
  down: 0,
};

const initialState: ThirdPartyApiState = {
  third_party_service_list: {
    total: 0,
    page: 1,
    page_size: 10,
    data: [],
  },
  third_party_service_summary: initialSummary,
  third_party_insurer_options: [],
};

const thirdPartyApiSlice = createSlice({
  name: "thirdPartyApi",
  initialState,
  reducers: {
    thirdPartyServiceList: (state, action: PayloadAction<ThirdPartyApiListResponse>) => {
      state.third_party_service_list = action.payload;

      if (action.payload.summary) {
        state.third_party_service_summary = action.payload.summary;
      }
    },

    thirdPartyServiceSummary: (state, action: PayloadAction<ThirdPartyApiSummary>) => {
      state.third_party_service_summary = action.payload;
    },

    thirdPartyInsurerOptions: (
      state,
      action: PayloadAction<ThirdPartyApiState["third_party_insurer_options"]>
    ) => {
      state.third_party_insurer_options = action.payload;
    },
  },
});

export const { thirdPartyServiceList, thirdPartyServiceSummary, thirdPartyInsurerOptions } =
  thirdPartyApiSlice.actions;

export default thirdPartyApiSlice.reducer;
